import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2CreateTableDialogProperties extends BasicDialogProperties {
    public functionOk: Function;

    constructor(functionOk: Function) {
        super();

        this.functionOk = functionOk;
    }
}
